import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const FullscreenIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M9 2h3.6l-4 4L10 7.4l4-4V7h2V0H9v2ZM6 8.6l-4 4V9H0v7h7v-2H3.4l4-4L6 8.6Z", fill: "currentColor" })));
});
FullscreenIcon.displayName = 'FullscreenIcon';
export default FullscreenIcon;
